/* v5.22 (Nov 4, John "A": "for realtors wanting to ship directly to clients homes ... have buttons for that"; reverses the Oct 28
   "never ship to buyers" rule). Agents choose "Ship to my office" (default) or "Ship to my client's new home" in the closing-gift
   builder (under the item cards) and in the cart (drawer + page, above CHECK OUT). Agents only: ?a=1, the agent pages, the 30-day
   agent memory (localStorage ctt_mode), or an agent cart.
   Client home (John "A", Nov 4: we EMAIL the agent's note to the client when it ships; Printify can't put a note in the box) adds
   fields saved as cart attributes, which become order custom attributes read by the Flow "Email gift note for client home delivery
   orders" and the john@ mailer. Attribute names are fixed, don't rename: Delivery (Office | Client home), Client name, Client email,
   Gift note (max 300, mirrored into the cart note), Gift from, Closing date. */
(function () {
  if (window.CTT_DELIVERY) return; window.CTT_DELIVERY = 1;
  var NOTE0 = 'Welcome home! — [Your name], [Brokerage]', FROM0 = '[Your name], [Brokerage]';
  var css = '.ctt-dlv{margin:14px 0 12px;text-align:left}' +
    '.ctt-dlv__k{margin:0 0 8px;font-family:var(--font-body--family);font-size:10.5px;letter-spacing:.26em;text-transform:uppercase;font-weight:500;color:#B08D57}' +
    '.ctt-dlv__seg{display:grid;grid-template-columns:1fr 1fr;border:1px solid #1F2A44}' +
    '.ctt-dlv__seg button{min-height:48px;padding:8px 10px;border:0;background:#fff;color:#1F2A44;font:inherit;font-size:12.5px;line-height:1.3;cursor:pointer}' +
    '.ctt-dlv__seg button+button{border-left:1px solid #1F2A44}' +
    '.ctt-dlv__seg button[aria-checked="true"]{background:#1F2A44;color:#fff}' +
    '.ctt-dlv__client{margin-top:12px;display:flex;flex-direction:column;gap:12px}.ctt-dlv__client[hidden]{display:none}' +
    '.ctt-dlv label{display:block;font-size:10.5px;letter-spacing:.18em;text-transform:uppercase;color:#6B6F7A}' +
    '.ctt-dlv textarea,.ctt-dlv input{display:block;width:100%;margin-top:5px;min-height:44px;padding:10px;border:1px solid #D8D1C5;background:#fff;color:#1F2A44;font:inherit;font-size:16px;letter-spacing:0;text-transform:none;border-radius:0;box-sizing:border-box}' +
    '.ctt-dlv textarea{min-height:78px;resize:vertical}' +
    '.ctt-dlv input[aria-invalid="true"]{border-color:#9B2C2C}' +
    '.ctt-dlv__hint{display:block;margin-top:5px;font-size:12px;letter-spacing:0;text-transform:none;color:#6B6F7A}' +
    '.ctt-dlv__err{display:block;margin-top:4px;font-size:12px;letter-spacing:0;text-transform:none;color:#9B2C2C}.ctt-dlv__err:empty{display:none}' +
    '.ctt-dlv__line,.ctt-dlv__multi{margin:0;font-size:12.5px;line-height:1.5;color:#3B4256}' +
    '.ctt-dlv__multi{margin-top:10px;color:#6B6F7A}' +
    '.ctt-hb-items+.ctt-dlv{margin:22px 0 8px;padding:18px 16px;background:#fff;border:1px solid #ECE6DC}' +
    // v5.23: on desktop the builder body is a 2-column grid (items | summary); keep the delivery box in the items column and the
    // summary in the right column next to both (without this the box took the right cell and pushed the summary under the items)
    // v5.23 (master): on desktop the navy summary and the delivery box share ONE sticky right column (.ctt-hb-side), so the ADD
    // button stays on screen next to the cards and the delivery choice sits right under it; phones keep the box under the cards
    '@media (min-width:750px){.ctt-hb-side{grid-column:2;grid-row:1;position:sticky;top:90px;align-self:start;max-height:calc(100vh - 100px);overflow-y:auto;scrollbar-width:thin}' +
    '.ctt-hb-side>.ctt-hb-sum{position:static;top:auto}.ctt-hb-side>.ctt-dlv{margin:12px 0 0;padding:16px;background:#fff;border:1px solid #ECE6DC}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  // field -> cart attribute (exact names; the Flow + mailer read them)
  var F = { cname: 'Client name', cemail: 'Client email', gnote: 'Gift note', gfrom: 'Gift from', close: 'Closing date' };
  var state = null;
  function agentMem() {
    if (/[?&]a=1(&|$)/.test(location.search) || /realtor-closing-gifts|business-gifts/.test(location.pathname)) return true;
    try { var v = (localStorage.getItem('ctt_mode') || '').split('|'); return v[0] === 'agent' && Date.now() - (+v[1] || 0) < 30 * 864e5; } catch (e) { return false; }
  }
  // one cart update at a time: two /cart/update.js calls in flight can overwrite each other's attributes, so changes are merged
  // into one pending body and sent in sequence
  var chain = Promise.resolve(), pend = null, flushT = 0;
  function post(body) {
    pend = pend || { attributes: {} };
    Object.keys(body.attributes || {}).forEach(function (k) { pend.attributes[k] = body.attributes[k]; });
    if ('note' in body) pend.note = body.note;
    clearTimeout(flushT);
    flushT = setTimeout(function () {
      var b = pend; pend = null;
      chain = chain.then(function () { return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) }); }).catch(function () {});
    }, 60);
    return chain;
  }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fromOf(note) { var m = /—\s*(.+)$/.exec(String(note || '').trim()); return m ? m[1].trim() : ''; }
  function emailOk(v) { return !v || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
  function field(label, input, extra) { return '<label>' + label + input + (extra || '') + '</label>'; }
  function html(where) {
    var home = state.delivery === 'Client home';
    return '<div class="ctt-dlv" data-ctt-dlv="' + where + '"><p class="ctt-dlv__k">Delivery</p>' +
      '<div class="ctt-dlv__seg" role="radiogroup" aria-label="Where should we ship it?">' +
      '<button type="button" role="radio" data-ctt-dlv-v="Office" aria-checked="' + !home + '">Ship to my office</button>' +
      '<button type="button" role="radio" data-ctt-dlv-v="Client home" aria-checked="' + home + '">Ship to my client’s new home</button></div>' +
      '<div class="ctt-dlv__client"' + (home ? '' : ' hidden') + '>' +
      field('Client’s name (optional)', '<input type="text" data-ctt-f="cname" autocomplete="off" maxlength="80" value="' + esc(state.cname) + '">') +
      field('Client’s email (optional)', '<input type="email" data-ctt-f="cemail" autocomplete="off" autocapitalize="off" spellcheck="false" maxlength="120" value="' + esc(state.cemail) + '">',
            '<span class="ctt-dlv__err" data-ctt-err></span><span class="ctt-dlv__hint">We’ll email your note to them when it ships. Used only for this gift.</span>') +
      field('Your note to them', '<textarea data-ctt-f="gnote" rows="3" maxlength="300">' + esc(state.gnote) + '</textarea>') +
      field('From', '<input type="text" data-ctt-f="gfrom" maxlength="120" value="' + esc(state.gfrom) + '">') +
      field('Closing date (optional)', '<input type="date" data-ctt-f="close" value="' + esc(state.close) + '">') +
      '<p class="ctt-dlv__line">Order within about 10 days of closing; made to order, arrives in 7–12 business days. Enter your client’s address at checkout.</p></div>' +
      (where === 'builder' ? '<p class="ctt-dlv__multi">Sending gifts to several clients? Place one order per client.</p>' : '') + '</div>';
  }
  function mounts() {
    var m = [];
    // builder: phones -> in the page column under the item cards (the summary is a sticky bar there, too small for the fields);
    // desktop -> under the navy summary inside one sticky right-column wrapper
    var desk = window.matchMedia && matchMedia('(min-width: 750px)').matches;
    [].forEach.call(document.querySelectorAll('.ctt-hb-ready .ctt-hb-body'), function (body) {
      var sum = body.querySelector(':scope > .ctt-hb-sum, :scope > .ctt-hb-side > .ctt-hb-sum');
      if (desk && sum) {
        var side = sum.parentNode.classList.contains('ctt-hb-side') ? sum.parentNode : null;
        if (!side) { side = document.createElement('div'); side.className = 'ctt-hb-side'; sum.parentNode.insertBefore(side, sum); side.appendChild(sum); }
        m.push([sum, 'afterend', 'builder']);
      } else {
        var items = body.querySelector('.ctt-hb-items'); if (items) m.push([items, 'afterend', 'builder']);
      }
    });
    [].forEach.call(document.querySelectorAll('.cart__ctas'), function (c) { m.push([c, 'beforebegin', 'cart']); });
    return m;
  }
  function paint() {
    if (!state || !state.agent) return;
    mounts().forEach(function (m) { if (!m[0].parentNode.querySelector(':scope > [data-ctt-dlv]')) m[0].insertAdjacentHTML(m[1], html(m[2])); });
  }
  function sync() {   // keep every copy (builder, drawer, page) and the theme's own cart-note field in step
    [].forEach.call(document.querySelectorAll('[data-ctt-dlv]'), function (b) {
      var home = state.delivery === 'Client home';
      [].forEach.call(b.querySelectorAll('[data-ctt-dlv-v]'), function (x) { x.setAttribute('aria-checked', String((x.getAttribute('data-ctt-dlv-v') === 'Client home') === home)); });
      b.querySelector('.ctt-dlv__client').hidden = !home;
      Object.keys(F).forEach(function (k) { var i = b.querySelector('[data-ctt-f="' + k + '"]'); if (i && document.activeElement !== i) i.value = state[k] || ''; });
    });
    if (state.delivery === 'Client home') [].forEach.call(document.querySelectorAll('textarea[name="note"]'), function (t) { if (document.activeElement !== t) t.value = state.gnote || ''; });
  }
  function load() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var a = c.attributes || {};
      state = { delivery: a.Delivery === 'Client home' ? 'Client home' : 'Office', agent: agentMem() || String(a.agent) === '1' || !!a.Delivery };
      Object.keys(F).forEach(function (k) { state[k] = a[F[k]] || ''; });
      if (state.agent && !a.Delivery) post({ attributes: { Delivery: 'Office' } });   // the default is on the order too
      paint(); sync();
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ctt-dlv-v]'); if (!b || !state) return;
    e.preventDefault();
    state.delivery = b.getAttribute('data-ctt-dlv-v');
    var body = { attributes: { Delivery: state.delivery } };
    if (state.delivery === 'Client home') {   // pre-fill the note + sender for the agent to edit
      if (!String(state.gnote).trim()) { state.gnote = NOTE0; body.attributes[F.gnote] = NOTE0; body.note = NOTE0; }
      if (!String(state.gfrom).trim()) { state.gfrom = fromOf(state.gnote) || FROM0; state._autoFrom = state.gfrom; body.attributes[F.gfrom] = state.gfrom; }
    }
    sync(); post(body);
  });
  var timers = {};
  function save(k) {
    clearTimeout(timers[k]);
    timers[k] = setTimeout(function () {
      var body = { attributes: {} }; body.attributes[F[k]] = state[k];
      if (k === 'gnote') body.note = state.gnote;   // mirror into the cart note
      post(body); sync();
    }, 450);
  }
  document.addEventListener('input', function (e) {
    var t = e.target; if (!state || !t.matches) return;
    var k = t.getAttribute('data-ctt-f');
    if (k === 'cemail') {
      var v = t.value.trim(), ok = emailOk(v), box = t.closest('label');
      t.setAttribute('aria-invalid', String(!ok));
      var er = box && box.querySelector('[data-ctt-err]'); if (er) er.textContent = ok ? '' : 'Please check the email address.';
      if (ok) { state.cemail = v; save('cemail'); }
    } else if (k && k !== 'close') {
      state[k] = t.value.slice(0, k === 'gnote' ? 300 : 120);
      if (k === 'gnote') {   // "From" follows the note's signature until the agent types their own
        var f = fromOf(t.value);
        if (f && (!state.gfrom || state.gfrom === state._autoFrom)) { state.gfrom = f; state._autoFrom = f; save('gfrom'); }
      }
      if (k === 'gfrom') state._autoFrom = null;
      save(k);
    } else if (t.matches('textarea[name="note"]') && state.delivery === 'Client home') { state.gnote = t.value.slice(0, 300); save('gnote'); }
  });
  document.addEventListener('change', function (e) {
    var t = e.target; if (!state || !(t.matches && t.matches('[data-ctt-f="close"]'))) return;
    state.close = t.value; save('close');
  });
  new MutationObserver(function () { if (state && state.agent) paint(); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
})();
